export default __webpack_public_path__ + "static/bell-938027c3dd8f049b98b93c747aa757f8.webp";